import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Newsletter functionality
    setEmail('');
  };

  return (
    <footer className="relative bg-gradient-to-br from-teal-800 to-teal-900 text-white overflow-hidden">
      {/* World Map Pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" viewBox="0 0 1200 600">
          <path d="M100,200 L150,180 L200,190 L250,170 L300,185 L350,175 L400,190 L450,180 L500,195 L550,185 L600,200" stroke="currentColor" strokeWidth="2" fill="none"/>
          <path d="M100,300 L150,280 L200,290 L250,270 L300,285 L350,275 L400,290 L450,280 L500,295 L550,285 L600,300" stroke="currentColor" strokeWidth="2" fill="none"/>
          <circle cx="200" cy="250" r="3" fill="currentColor"/>
          <circle cx="400" cy="220" r="3" fill="currentColor"/>
          <circle cx="600" cy="280" r="3" fill="currentColor"/>
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-16">
        {/* Top Section */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand & Newsletter */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <img 
                src="https://static.readdy.ai/image/26698e5f43d9efce92e955285c2ce22e/9e290fb29da60fa3221d2a96bd0f35fd.png" 
                alt="Logo" 
                className="h-10 w-auto"
              />
            </div>

            <form onSubmit={handleNewsletterSubmit} className="mb-8">
              <div className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Seu e-mail"
                  className="flex-1 px-5 py-3 bg-transparent border-2 border-white/30 rounded-xl text-white placeholder-white/60 focus:border-white focus:outline-none text-sm"
                />
                <button 
                  type="submit"
                  className="w-12 h-12 bg-lime-400 hover:bg-lime-500 rounded-full flex items-center justify-center transition-colors flex-shrink-0 cursor-pointer"
                >
                  <i className="ri-notification-line text-gray-900 text-xl"></i>
                </button>
              </div>
            </form>

            <div className="text-2xl font-serif leading-tight">
              Próximo Desafio<br />
              <span className="text-3xl font-bold">Começa dia 7 Janeiro</span>
            </div>
          </div>

          {/* Navigation Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Programa</h4>
            <ul className="space-y-3">
              <li>
                <a href="#como-funciona" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Sobre
                </a>
              </li>
              <li>
                <a href="#como-funciona" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Como Funciona
                </a>
              </li>
              <li>
                <a href="#antes-depois" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Resultados
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Recursos</h4>
            <ul className="space-y-3">
              <li>
                <a href="#vantagens" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Receitas
                </a>
              </li>
              <li>
                <a href="#vantagens" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Treinos
                </a>
              </li>
              <li>
                <a href="#vantagens" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Comunidade
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Suporte</h4>
            <ul className="space-y-3">
              <li>
                <a href="#contato" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#contato" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Contato
                </a>
              </li>
              <li>
                <a href="#contato" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Ajuda
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            {/* Copyright */}
            <div className="text-sm text-white/70">
              © 2025 Desafio 10 Dias. Todos os direitos reservados. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Website Builder</a>
            </div>

            {/* Social Media */}
            <div className="flex gap-4">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border-2 border-white/30 hover:border-white rounded-xl flex items-center justify-center transition-colors cursor-pointer group">
                <i className="ri-instagram-line text-lg group-hover:scale-110 transition-transform"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border-2 border-white/30 hover:border-white rounded-xl flex items-center justify-center transition-colors cursor-pointer group">
                <i className="ri-facebook-fill text-lg group-hover:scale-110 transition-transform"></i>
              </a>
              <a href="https://wa.me/5511999999999" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border-2 border-white/30 hover:border-white rounded-xl flex items-center justify-center transition-colors cursor-pointer group">
                <i className="ri-whatsapp-line text-lg group-hover:scale-110 transition-transform"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border-2 border-white/30 hover:border-white rounded-xl flex items-center justify-center transition-colors cursor-pointer group">
                <i className="ri-youtube-fill text-lg group-hover:scale-110 transition-transform"></i>
              </a>
            </div>

            {/* Privacy Links */}
            <div className="text-sm text-white/70">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">Política de Privacidade</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
